<template>
  <Modal :id="'cmp-distribution-suppliers-add_new_stock'" @cancelled="onCancel">
    <template slot="header">{{
      $dft.snakeCaseToWords("Create Supplier Order")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            class="m1"
            :type="'date'"
            :id="'order_date'"
            required
            :value="supplierOrderDate"
            :placeholder="$t('order_date')"
            @valuechanged="onDateChange"
          >
          </TextField>
          <Dropdown
            :listHeight="500"
            :id="'supply_order_type'"
            class="m2"
            :options="supplier_typeTV"
            :selected="
              supplier_typeTV.find((b) => b.value == supply_order_type)
            "
            :placeholder="$t('supply_type')"
            box
            @selectedChange="(b) => onDropdownChange('supply_order_type', b)"
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onSave">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>
  
  <script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { EventHooks } from "../../../../plugins/text-field";
import { SuppliersService } from "../../services/suppliers.service";
import { createTV } from "../../../../models/text-value.model";
export default {
  components: {
    Modal,
    TextField,
  },
  props: ["selectedSupplierDetails"],
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        isModel: true,
      },
      supply_order_type: 1,
      supplierOrderDate: null,
      supply_order_types: [],
    };
  },
  mounted: function () {
    SuppliersService.createSupplierOrderModalData({
      supplier_id: this.supplier_id,
    }).then((res) => {
      this.supply_order_types = res.data.supply_order_types;
    });
  },

  computed: {
    supplier_id: function () {
      return this.$route.params.supplier_id;
    },
    supplier_typeTV: function () {
      return this.supply_order_types.map((s) => {
        return {
          text: this.$t(s.textkey),
          value: s.value,
        };
      });
    },
  },
  methods: {
    onDropdownChange: function (name, value) {
      this.supply_order_type = value.value;
      this.supply_order_type_name = value.text;
    },
    onDateChange: function (name, value) {
      this.supplierOrderDate = value;
    },
    onSave: async function () {
      const products = this.selectedSupplierDetails.stocKProducts.map((sp) => {
        return {
          product_id: "",
          suggested_order_qty: sp.suggested_order_qty,
        };
      });
      console.log('products',products)
      const res = await SuppliersService.createSupplyOrderData({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        supply_order_type: this.supply_order_type,
        order_date: this.supplierOrderDate,
        products: JSON.stringify(products),
      });
       console.log("res",res)
      this.$emit("added", {
        ...res.data,
        supply_order_type: this.supply_order_type,
      });
      this.onCancel();
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>
  
  <style></style>
  